<template>
  <div>
    <b-card>
      <b-tabs>
        <b-tab title="Relevância de Conteúdo">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="12"></b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <label for="content-list">Tipo de Conteúdo</label>
                  <b-form-group label="Tipo de Conteúdo" label-for="content-list">
                    <v-select
                      id="content-list"
                      v-model="form.content"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="contents"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.origin"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="origins"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <label for="channel-list">Canal</label>
                  <b-form-group label="Canal" label-for="channel-list">
                    <v-select
                      id="channel-list"
                      v-model="form.channel"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="channels"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12"></b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input
                    id="relevance"
                    type="number"
                    min="1"
                    max="10"
                    placeholder="Relevância"
                    v-model="form.relevance"
                  />
                  <label for="relevance">Relevância</label>
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import contentRelevanceService from "@/providers/contentRelevanceService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import AppConstants from '@/appConstants';
import vSelect from "vue-select";

export default {
  props: {},
  data() {
    return {
      dataID: null,
      contents: [],
      origins: [],
      channels: [],
      form: {
        _id: "",
        content: "",
        origin: "",
        channel: "",
        relevance: "",
        active: true,
        dt_create: "",
        dt_update: "",
        email_create: "",
        email_update: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Nova Relevância de Conteúdo');
    this.loadData();
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      this.getContentRelevanceDetail();
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_CONTENT_RELEVANCE);
    },
    onSubmit() {
      const relevance = parseInt(this.form.relevance, 10);
      if (!Number.isInteger(relevance) || relevance < 1 || relevance > 10 || relevance != this.form.relevance) {
        messagesNotifyHelper.errorNotify('Relevância de Conteúdo', 'Relevância deve ser um número inteiro entre 1 e 10.');
        return;
      }
      if (!this.form.content || !this.form.origin || !this.form.channel) {
        messagesNotifyHelper.errorNotify('Relevância de Conteúdo', 'Tipo de conteúdo, origem e canal são obrigatórios.');
        return;
      }

      const form = JSON.parse(JSON.stringify(this.form));
      form.content = form.content.id || form.content._id;
      form.origin = form.origin.id || form.origin._id;
      form.channel = form.channel.id || form.channel._id;
      form.relevance = relevance;
      contentRelevanceService
        .registerContentRelevance(form, new URLSearchParams())
        .then(() => {
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getContentRelevanceDetail() {
      const params = new URLSearchParams();
      contentRelevanceService
        .getContentRelevanceDetails(this.dataID, params)
        .then((res) => {
          this.form._id = res._id;
          this.form.content = res.content;
          this.form.origin = res.origin;
          this.form.channel = res.channel;
          this.form.relevance = res.relevance;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getContent(new URLSearchParams()),
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getChannel(new URLSearchParams()),
      ])
        .then((res) => {
          this.contents = res[0];
          this.origins = res[1];
          this.channels = res[2];
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
  },
};
</script>

<style lang="scss">
</style>
